import Cookies from 'universal-cookie';
import URI from 'urijs';

export const cookies = new Cookies(null, {
  path: '/', domain: `.${new URI(window.location.href).domain()}`, sameSite: 'lax',
});
